import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PaymentsComponent } from '@sdvor/payment/ui';
import { SdHeadingComponent } from '@sdvor/seo/ui';

@Component({
  selector: 'sd-payments-page',
  templateUrl: './payments-page.component.html',
  imports: [SdHeadingComponent, PaymentsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsPageComponent {}
